<template>
  <div :class="{ 'timer-picker_active': active, 'timer-picker-wrap': true}" @click="showPicker">
    <span v-if="value" class="time-picker-text">{{ value }}</span>
    <span v-else class="time-picker-placeholder">{{ _placeholder }}</span>
  </div>
</template>

<script>

function todayZero () {
  const now = new Date()
  return new Date(now.getFullYear(), now.getMonth(), now.getDate())
}
function todayEnd () {
  return new Date(+todayZero() + (24 * 60 * 60 - 1) * 1000)
}
export default {
  props: {
    disabled: {},
    value: {},
    autoPop: {},
    placeholder: {},
    day: {},
    minuteStep: {
      default: 1
    },
    delay: {},
    min: {
      default: () => todayZero()
    },
    max: {
      default: () => todayEnd()
    },
    title: {},
    subtitle: {},
    cancelTxt: {},
    confirmTxt: {},
    swipeTime: {},
    visible: {},
    maskClosable: {},
    format: {
      default: 'YYYY-MM-DD HH:mm'
    },
    zIndex: {}
  },
  data () {
    return {active: false}
  },
  created () {
    this.picker = this.$createTimePicker({
      $props: {
        day: 'day',
        minuteStep: 'minuteStep',
        delay: 'delay',
        min: 'min',
        max: 'max',
        title: 'title',
        subtitle: 'subtitle',
        cancelTxt: 'cancelTxt',
        confirmTxt: 'confirmTxt',
        swipeTime: 'swipeTime',
        visible: 'visible',
        maskClosable: 'maskClosable',
        format: 'format',
        zIndex: 'zIndex'
      },
      $events: {
        select: 'selectHandler',
        cancel: this.hided
      }
    })
    this.autoPop && this.showPicker()
  },
  methods: {
    showPicker () {
      if (this.disabled) {
        return
      }
      this.picker.show()
      this.active = true
    },
    hided () {
      this.active = false
    },
    selectHandler (selectedTime, selectedText, formatedTime) {
      this.hided()
      if (formatedTime !== this.value) {
        this.$emit('input', formatedTime)
        this.$emit('change', formatedTime)
      }
    }
  },
  computed: {
    _placeholder () {
      return this.placeholder || ''
    }

  }
}
</script>
<style lang="scss" scoped>
@import "./style.scss";
</style>
